<script>
  import { geoPath, geoCircle } from "d3-geo";
  import { line, curveNatural, scaleOrdinal, scaleLinear, randomInt, scaleSqrt } from "d3";
	import { greatcircles, ports, routes, schools } from './geodata.js'
  import { fly,fade,crossfade } from 'svelte/transition';
  import { tweened } from "svelte/motion";

  export let width;
  export let height;
  export let projection;
	export let activeLayer;
  export let step;
  export let hovered;
  export let colors;
  export let quantity;
  export let etype
  let denom

  $: tot_quantity = etype+quantity

  $: {denom = etype=='NO2'?10:5
console.log(denom)}


  function randomIntFromInterval(min, max) { // min and max included 
  return Math.floor(Math.random() * (max - min + 1) + min)
}


  // let colors = ["#FEE598","#FFC652","#FF9A2B","#EF7310","#CE4A02","#923103","#712504"]


  
  let rScale = scaleSqrt().domain([0,1000]).range([0,25])




  $: path = geoPath().projection(projection);

  const lineGenerator = line().curve(curveNatural);
</script>

<svg {width} {height}>
    {#if step >0}
    {#each schools.features as school,i}
      <circle
        cx={projection([school.school_longitude,school.school_latitude])[0]}
        cy={projection([school.school_longitude,school.school_latitude])[1]}
        r={rScale(school.students)}
        fill={school[tot_quantity]<denom?
        colors[0]:colors[parseInt(Math.floor(school[tot_quantity]/denom))]}

      opacity={hovered!=null?
        
      (hovered==0?

      (school[tot_quantity]<denom ? 0.8:0.1):
      (parseInt(Math.floor(school[tot_quantity]/denom))==hovered?.8:0.1)
  
      )
      : .8} 


       in:fade={{ duration: 1000,delay: 10*i}} out:fade={{ duration: 1000,delay: 2*i}} 

      />
    {/each}
    {/if}

    <rect x={width-110} y=300 height=110 width=100 fill='white' rx=10 ry=10 stroke-width=2px stroke= '#ddd'></rect>
    <text class='tit' x={width-100} y=320 font-weight="bold">STUDENTS</text>

    <circle cx={width-70} cy=370 r =25 fill='white' stroke-width=1px stroke= '#555'></circle>
    <circle cx={width-70} cy=378 r ={rScale(500)} fill='white' stroke-width=1px stroke= '#555'></circle>
    <circle cx={width-70} cy=387 r ={rScale(100)} fill='white' stroke-width=1px stroke= '#555'></circle>
    <text x={width-40} y=345>1000</text>
    <line x1={width-40} x2={width-70} y1=345 y2=345 stroke-width=1px stroke='black'></line>


    <text x={width-40} y={342 +rScale(500)}>500</text>
    <line x1={width-40} x2={width-70} y1={342+rScale(500)} y2={342+rScale(500)} stroke-width=1px stroke='black'></line>



    <text x={width-40} y={379 }>100</text>
    <line x1={width-40} x2={width-70} y1={379} y2={379} stroke-width=1px stroke='black'></line>

<!-- 
    opacity={hovered? 
      (school.emissions==hovered?.8:0.1)
    : .8}  -->

    <!-- 
  opacity={hovered? 
    (school[tot_quantity]==hovered?.8:0.1)
  : .8} -->

     <!-- {#each data.features as route}
      <path
        d={lineGenerator(route.geometry.coordinates.map((d) => projection(d)))}
        fill="none"
        stroke-width={4}
        stroke={colScale(route.properties.NO2_ugm3)}
      />
      {/each} -->

	
	<!-- {#if activeLayer == 'routes'}
    <!-- {#each data.features as route}
    {#if (route.properties.NO2points>100)&&(route.properties.osm_fclass != 'residential')}
      <path
        d={lineGenerator(route.geometry.coordinates.map((d) => projection(d)))}
        fill="none"
        stroke-width={4}
        stroke={colScale(route.properties.NO2_ugm3)}
      /> -->

      <!-- <circle
      cx={projection(route.geometry.coordinates[0])[0]}
      cy={projection(route.geometry.coordinates[0])[1]}
      r={rScale(route.properties.NO2_ugm3)}
      fill={colScale(route.properties.NO2_ugm3)}


    
    {/if}

    {/each}

  

	{/if}     /> -->

				
</svg>

<style>
	text {
    font-size: 0.6em;
		text-shadow: -1px -1px white, -1px 1px white, 1px 1px white, 1px -1px white, -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white;
	}


  .tit {
    font-size: .8rem !important;
	}


  circle{
    transition: fill 500ms;
  }
</style>
